<template>
  <!-- BEGIN: Content-->
  <div>
    <CommonTable
        :url="url"
        :tableHeaderValues="tableHeaderValues"
        :actions="actions"
        :deleteActions="deleteActions"
        :mutedData="mutedData"
        :storageKey="storageKey"
        :externalTotalRecord="externalTotalRecord"
        :filteredData="filteredData"
        :showPerPage = true
        :hideAllPerPage="true"
        @getFullResponse="getFullResponse"
    />


  </div>
  <!-- END: Content-->
</template>

<script>


export default {
  props:['filter'],
  components:{

  },
  mounted() {
    localStorage.setItem("url", "v1/get-transfer-pending-transactions");
    this.checkDataInStore('v1/get-transfer-pending-transactions')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      exportData:{
        cta: (exportType) => {
          this.$emit('exportData',exportType)
        }
      },
      showChargesModal: false,
      chargesData: [],
      url: "v1/get-transfer-pending-transactions",
      storageKey: "transfer-pending-transactions",
      isDefault: false,
      tableHeaderValues: [
        {
          title: "Transaction Id",
          valueKey: "uuid",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary font-weight-bolder" style="cursor: pointer">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            this.copyText(row.uuid);
            this.$router.push({name: 'transactions-detail',params: {id:row.uuid}})
          }
        },
        {
          title: "Receiver Email/Phone",
          valueKey: "email",
          html: true,
          alter: function(value,row) {
            var html = "";
            if (typeof(row.phone_number) != 'undefined' && row.phone_number != '') {
              html = `<span class="text-info">${value+' / '+row.phone_number}</span>`;
              return html;
            } else {
              html = `<span class="text-info">${value}</span>`;
              return html;
            }
          }
        },
        {
          title: "Sender",
          valueKey: "user_account.account_title",
          html: true,
          alter: function(value,row) {
            var html = "";
            if (typeof(row.user_account.user) != 'undefined') {
              html = `<span class="text-warning">${value+' / '+row.user_account.user.email}</span>`;
              return html;
            } else {
              html = `<span class="text-warning">${value}</span>`;
              return html;
            }
          }
        },
        {
          title: "Deduct Charges",
          valueKey: "deduct_charges_from_transaction",
          html: true,
          alter: function(value) {
            if (value == 1) {
              return `<a href="javascript:void()" class="badge badge-glow badge-light-primary">Yes</a>`;
            } else {
              return `<a href="javascript:void()" class="badge badge-glow badge-light-primary">No</a>`;
            }
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, obj) {
            var html = "";
            if (obj.status == 1)
              html = `<div class="badge badge-pill  badge-glow badge-success">DONE</div>`;
            else if (obj.status == 2)
              html = `<div class="badge badge-pill  badge-glow badge-danger">CANCELED</div>`;
            else if (obj.status == 3)
              html = `<div class="badge badge-pill  badge-glow badge-primary">SUSPENDED</div>`;
            else
              html = `<div class="badge badge-pill  badge-glow badge-warning">PENDING</div>`;
            return html;
          }
        },
        {
          title: 'Currency',
          valueKey: 'user_account.currency.code',
          html: true,
          alter: function(value,row) {
            var html=''
            if(value)
              html = `<div class="badge-success badge badge-light-success">${value}</div>`


            return  html


          }
        },
        {
          title: 'Amount',
          valueKey: 'amount',
          html: true,
          alter: (value,row) => {
            var html=''
            if(value)
              html = `<div  class="font-lg-4 font-weight-bolder text-dark">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</div>`


            return  html


          }
        },
        {
          title: "Created Date / Time",
          titleHtml: `<span class="text-warning font-weight-bolder">
														(Showing In GMT)
													</span>`,
          valueKey: "created_at",
          html: true,
          alter: (value,row) => {
            var html='-'
            if(value)
              html = ` <div  class=" font-weight-bolder text-dark">${new Date(value).toISOString().slice(0, 16).replace('T', ' ')}</div>`



            return  html


          }
          // alter: (value)=> {
          //   // return this.customFormatDateTime(value)
          //   return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
          // }
        },
      ],
      actions: [

      ],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      filteredData:{},

    };
  },
  methods: {
    getFullResponse(response) {
      this.$emit('dataFetched',response)
    },
  },
  watch:{
    // filter(val){
    //   this.filteredData = val
    // }
    filter: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler (val, oldVal) {
        let temp = val
        temp.tabToShow = 4
        this.filteredData = temp
      }
    }
  }
};
</script>
